import React, { useState, useEffect, useMemo, useRef } from 'react';
import { Autocomplete, TextField, Table, TableBody, TableCell, TableContainer, Box, CircularProgress, TableHead, TableRow, Paper, Button, TablePagination, Checkbox, Grid, Modal, Dialog, DialogTitle, DialogContent, IconButton, Typography, Alert, Collapse, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import GestionCotizaciones from './GestionCotizacion'; // Asegúrate de que la ruta sea correcta
import GestionOrdenTrabajo from './GestionOrdenTrabajo';
import Swal from 'sweetalert2';

const swalWithHighZIndex = Swal.mixin({
    zIndex: 9999
});
import GestionFactura from './GestionFactura'; // Ajusta la ruta si es necesario
import dayjs from 'dayjs';
import Resultados from './Resultados';
import { useSucursal } from '../contexts/SucursalContext';
import { useUser } from '../contexts/UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faMobileAlt, faEnvelope, faPrint, faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';
import TomaMuestra from '../Analisis/TomaMuestra';
import ComentariosEntregaModal from './ComentariosEntregaModal';
import PdfPreviewModal from './PdfPreviewModal';
import { useAccesos } from '../contexts/AccesosContext';
function AnalisisClientes() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [analisisClientes, setAnalsisClientes] = useState([]);
    const [analisis, setAnalisis] = useState([]);
    const [totalAnalisisClientes, setTotalAnalisisClientes] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedAnalisisClientes, setSelectedAnalisisClientes] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [ordenTrabajoData, setOrdenTrabajoData] = useState(null);
    const [ordenTrabajoCliente, setOrdenTrabajoCliente] = useState([]);

    const [detallesOrdenTrabajo, setDetallesOrdenTrabajo] = useState([]);
    const [detallesOrdenTrabajoInfo, setDetallesOrdenTrabajoInfo] = useState([]);
    const [openFacturaModal, setOpenFacturaModal] = useState(false);
    const [facturaData, setFacturaData] = useState(null);
    const [detalleSeleccionado, setDetalleSeleccionado] = useState(null);
    const [loading, setLoading] = useState(false);

    const [sucursales, setSucursales] = useState([]);
    const { sucursalSeleccionada, setSucursalSeleccionada } = useSucursal();
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [abreviatura, setAbreviatura] = useState('');

    const [openResultadosModal, setOpenResultadosModal] = useState(false);
    const [numericCodigo, setNumericCodigo] = useState(null);
    const [selectedModulo, setSelectedModulo] = useState(null); // Nuevo estado para Módulo
    const [modulos, setModulos] = useState([]); // Estado para guardar los módulos obtenidos
    const { user } = useUser();
    const [selectedDetalles, setSelectedDetalles] = useState([]);
    const [openTomaMuestra, setOpenTomaMuestra] = useState(false);
    const [selectedAnalisisIdForToma, setSelectedAnalisisIdForToma] = useState(null);
    const [openComentarioEntrega, setOpenComentarioEntrega] = useState(false);
    const [comentariosEntrega, setComentariosEntrega] = useState([]);

    // Legacy preview state (URL generated by backend using idDetalle)
    const [openLegacyModal, setOpenLegacyModal] = useState(false);
    const [legacyUrl, setLegacyUrl] = useState(null);
    const [legacyLoading, setLegacyLoading] = useState(false);
    const [legacyError, setLegacyError] = useState(null);
    const refAutocompleteAnalisis = useRef();
    const [analisisSeleccionado, setAnalisisSeleccionado] = useState(null);
    const [idOrdenTrabajo, setIdOrdenTrabajo] = useState(null);
    const [filteredAnalisis, setFilteredAnalisis] = useState([]);

    // Estados para el filtro de módulos en detalles y agrupamiento
    const [selectedModuloDetalle, setSelectedModuloDetalle] = useState(
        localStorage.getItem('selectedModuloDetalle') ? 
        JSON.parse(localStorage.getItem('selectedModuloDetalle')) : null
    );
    const [modulosDetalles, setModulosDetalles] = useState([]);
    const [expandedModules, setExpandedModules] = useState({});

    // PDF Preview Modal states
    const [openPdfPreview, setOpenPdfPreview] = useState(false);
    const [pendingValidationAction, setPendingValidationAction] = useState(null);

    // Reimprimir PDF states
    const [openReimprimirPreview, setOpenReimprimirPreview] = useState(false);
    const [reimprimirPdfUrl, setReimprimirPdfUrl] = useState(null);
    const [reimprimirLoading, setReimprimirLoading] = useState(false);
    const [reimprimirError, setReimprimirError] = useState(null);

    // Estados para modal de preview de etiquetas
    const [openEtiquetasPreview, setOpenEtiquetasPreview] = useState(false);
    const [etiquetasPdfUrl, setEtiquetasPdfUrl] = useState(null);

    // Estados para modal de preview de orden
    const [openOrdenPreview, setOpenOrdenPreview] = useState(false);
    const [ordenPdfUrl, setOrdenPdfUrl] = useState(null);

    const handleAnalisisKeyDown = async (e, analisis) => {
        if (e.key === 'Enter') {
            e.preventDefault();

            if (analisis) {
                await handleSeleccionAnalisis(analisis); // Asigna valores (precio, descuento, etc.)
                setAnalisisSeleccionado(analisis);       // Guarda en el estado global (por si lo necesitás más adelante)
                handleAgregarAnalisisConParametro(analisis); // Pasa directo el análisis a agregar
            }
        }
    };

    // Funciones para determinar si se puede prevalidar/validar/invalidar
    // idTipoAprobacion: 1 = Sin Validar, 2 = Pre Valido, 3 = Validado
    const puedePrevalidar = (detalle) => {
        return !detalle.idTipoAprobacion || detalle.idTipoAprobacion === 1;
    };

    const puedeValidar = (detalle) => {
        return detalle.idTipoAprobacion === 2;
    };

    const puedeInvalidar = (detalle) => {
        return detalle.idTipoAprobacion === 3;
    };

    const puedeQuitarPrevalidacion = (detalle) => {
        return detalle.idTipoAprobacion === 2;
    };

    // Funciones para verificar estado de múltiples detalles seleccionados
    const todosLosSeleccionadosPuedenPrevalidar = () => {
        return selectedAnalisisClientes.length > 0 && selectedAnalisisClientes.every(d => puedePrevalidar(d));
    };

    const todosLosSeleccionadosPuedenValidar = () => {
        return selectedAnalisisClientes.length > 0 && selectedAnalisisClientes.every(d => puedeValidar(d));
    };

    const todosLosSeleccionadosPuedenInvalidar = () => {
        return selectedAnalisisClientes.length > 0 && selectedAnalisisClientes.every(d => puedeInvalidar(d));
    };

    const todosLosSeleccionadosPuedenQuitarPrevalidacion = () => {
        return selectedAnalisisClientes.length > 0 && selectedAnalisisClientes.every(d => puedeQuitarPrevalidacion(d));
    };

    // useEffect para obtener los módulos (ejemplo: módulos de tipo 1)
    useEffect(() => {
        const fetchModulos = async () => {
            try {
                const response = await fetch(`${server}/MgModuloes/porIdTipo/1`);
                if (response.ok) {
                    const data = await response.json();
                    setModulos(data.$values || []);
                    console.log(data.$values);
                } else {
                    console.error("Error al obtener modulos");
                }
            } catch (error) {
                console.error("Error al obtener modulos:", error);
            }
        };

        const fetchAnalisis = async () => {
            try {
                const response = await fetch(`${server}/MgAnalisisGeneralTiposDeAnalisis`);
                const data = await response.json();
                setAnalisis(data.$values);
                console.log(data.$values);
            } catch (error) {
                console.error('Error al cargar los tipos de analisis:', error);
            }
        };

        fetchModulos();
        fetchAnalisis();
    }, [server]);

    useEffect(() => {
    if (selectedModulo) {
        // Filter analyses by the selected module using client-side filtering
        const filtered = analisis.filter(item => 
            item.idModulo === selectedModulo.idModulo
        );
        setFilteredAnalisis(filtered);
        // Reset selected analysis when changing module
        setAnalisisSeleccionado(null);
    } else {
        // If no module selected, show all analyses
        setFilteredAnalisis(analisis);
    }
}, [selectedModulo, analisis]);

    useEffect(() => {
        if (sucursalSeleccionada && fechaInicio && fechaFin) {
            fetchAnalisisClientes(searchQuery, fechaInicio, fechaFin);
        }
    }, [sucursalSeleccionada, fechaInicio, fechaFin]);

    useEffect(() => {
        if (sucursalSeleccionada && sucursales.length > 0) {
            const encontrada = sucursales.find(s => s.idSucursal === sucursalSeleccionada.idSucursal);
            if (encontrada) {
                setSucursalSeleccionada(encontrada); // ahora sí, objeto completo con abreviatura
            }
        }
    }, [sucursales]);


    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };
    // Función para cargar ordenes de trabajo desde la API con paginación y búsqueda
    // --- OBTENER ORDENES DE TRABAJO ---
    // Podrás pasar manualmente fechaInicio y fechaFin para la primera carga
    const fetchAnalisisClientes = async (
        search = '',
        fi = fechaInicio,
        ff = fechaFin
    ) => {
        try {
            setLoading(true);
            const bodyData = {
                page: 1,
                limit: 100,
                search,
                idSucursal: sucursalSeleccionada ? sucursalSeleccionada.idSucursal : 0,
                fechaInicio: fi,
                fechaFin: ff,
                idModulo: selectedModulo ? selectedModulo.idModulo : "",
                idAnalisis: analisisSeleccionado ? analisisSeleccionado.idTipoAnalisis : null

            };
            console.log(bodyData);
            const response = await fetch(`${server}/MgOrdenesMedicas/AnalisisPaginados`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(bodyData),
            });

            const data = await response.json();
            console.log('=== ESTRUCTURA DE DATOS API ===');
            console.log('Primer registro completo:', data.cotizaciones.$values?.[0]);
            if (data.cotizaciones.$values?.[0]) {
                console.log('Campo valorVenta:', data.cotizaciones.$values[0].valorVenta);
                console.log('Campo valorDescuento:', data.cotizaciones.$values[0].valorDescuento);
                console.log('Campo tipoValidacion:', data.cotizaciones.$values[0].tipoValidacion);
                console.log('Campo aprobadoPorNombre:', data.cotizaciones.$values[0].aprobadoPorNombre);
                console.log('Campo nombreCompleto:', data.cotizaciones.$values[0].nombreCompleto);
                console.log('Campo descripcionTipoAnalisis:', data.cotizaciones.$values[0].descripcionTipoAnalisis);
            }
            console.log('Campos disponibles:', data.cotizaciones.$values?.[0] ? Object.keys(data.cotizaciones.$values[0]).sort() : []);
            console.log('Total registros:', data.cotizaciones.$values?.length);
            console.log('====================================');
            setAnalsisClientes(data.cotizaciones.$values || []);
            setTotalAnalisisClientes(data.total || 0);
        } catch (error) {
            console.error('Error al cargar las órdenes de trabajo:', error);
            setAnalsisClientes([]);
            setTotalAnalisisClientes(0);
        } finally {
            setLoading(false);
        }
    };

    // --- useEffect: Montaje ---
    useEffect(() => {
        const fetchDataInicial = async () => {
            try {
                const now = new Date();
                const startDate = new Date();
                startDate.setMonth(startDate.getMonth() - 3);
                const tomorrow = new Date();
                tomorrow.setDate(tomorrow.getDate() + 1);

                const defaultInicio = startDate.toISOString().split('T')[0];
                const defaultFin = tomorrow.toISOString().split('T')[0];

                // Cargar sucursales
                const response = await fetch(`${server}/MgSucursales`);
                const data = await response.json();
                const lista = data.$values || data;
                setSucursales(lista);

                // Establecer fechas
                setFechaInicio(defaultInicio);
                setFechaFin(defaultFin);

                // ❌ No seteamos sucursalSeleccionada aquí
            } catch (error) {
                console.error('Error al inicializar datos:', error);
            }
        };

        fetchDataInicial();
    }, []);




    // --- OBTENER SUCURSALES ---
    const fetchSucursales = async () => {
        try {
            const response = await fetch(`${server}/MgSucursales`);
            const data = await response.json();
            const lista = data.$values || data;
            setSucursales(lista);
        } catch (error) {
            console.error('Error al obtener sucursales:', error);
        }
    };

    // --- MANEJADORES SUCURSAL / FECHA / BUSCAR ---
    const handleSucursalSeleccionada = (event, newValue) => {
        console.log(newValue);

        if (newValue) setSucursalSeleccionada(newValue);
        else setSucursalSeleccionada(null);
    };
    const handleFechaInicioChange = (e) => setFechaInicio(e.target.value);
    const handleFechaFinChange = (e) => setFechaFin(e.target.value);


    // Manejar cambio en el campo de búsqueda
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    // Manejar búsqueda al hacer clic en el botón
    const handleSearch = () => {
        setPage(0);
        fetchAnalisisClientes(searchQuery, fechaInicio, fechaFin);
    };

    // Manejar cambio de página
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Manejar cambio en el número de filas por página
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSelectDetalle = (idDetalle) => {
        console.log(idDetalle);
        setDetalleSeleccionado(idDetalle);
    };


    // Manejar selección de análisis - Permite seleccionar múltiples análisis del mismo módulo/orden
    const handleSelectOrdenTrabajo = (ordenTrabajo) => {
        setSelectedAnalisisClientes((prev) => {
            const yaSeleccionado = prev.some(a => a.idDetalle === ordenTrabajo.idDetalle);

            if (yaSeleccionado) {
                // Si ya está seleccionado, lo removemos
                return prev.filter(a => a.idDetalle !== ordenTrabajo.idDetalle);
            } else {
                // Verificar si hay selecciones previas de otro módulo/orden
                if (prev.length > 0) {
                    const primerSeleccionado = prev[0];
                    // Si es del mismo módulo y orden, permitir agregar
                    if (primerSeleccionado.idOrdenMedica === ordenTrabajo.idOrdenMedica && 
                        primerSeleccionado.idModulo === ordenTrabajo.idModulo) {
                        return [...prev, ordenTrabajo];
                    } else {
                        // Si es de otro módulo/orden, reemplazar toda la selección
                        return [ordenTrabajo];
                    }
                } else {
                    // Si no hay selección previa, agregar
                    return [ordenTrabajo];
                }
            }
        });
    };




    // Acciones con la cotización seleccionada
    const handleImprimirSobre = async () => {
        if (selectedAnalisisClientes.length === 0) {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            });
            return;
        }

        const selectedAnalisisCliente = selectedAnalisisClientes[0];
        
        try {
            ///api/MgOrdenesMedicas/ImprimirOrdenMedica/{idOrden}
            const response = await fetch(`${server}/MgOrdenesMedicas/ImprimirOrdenMedica/${selectedAnalisisCliente.idOrdenMedica}`, {
                method: 'POST',
            });

            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const newWindow = window.open(url, '_blank');
                if (newWindow) {
                    newWindow.focus();
                } else {
                    alert('Por favor, permite las ventanas emergentes para previsualizar el documento.');
                }
            } else {
                console.error('Error al imprimir la orden de trabajo');
                alert('Hubo un error al imprimir la orden de trabajo.');
            }
        } catch (error) {
            console.error('Error al imprimir la orden de trabajo:', error);
            alert('Hubo un error al imprimir la orden de trabajo.');
        }
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxHeight: '90vh',
        overflowY: 'auto',
        backgroundColor: '#fff',
        padding: '20px',
        boxShadow: 24,
        outline: 'none',
    };

    const paginatedAnalisisClientes = useMemo(() => {
        const start = page * rowsPerPage;
        const end = start + rowsPerPage;
        return analisisClientes.slice(start, end);
    }, [analisisClientes, page, rowsPerPage]);

    // Función para agrupar análisis por orden y módulo
    const analisisAgrupadosPorOrdenYModulo = useMemo(() => {
        const grupos = {};
        
        paginatedAnalisisClientes.forEach(analisis => {
            const key = `${analisis.idOrdenMedica}-${analisis.idModulo}`;
            
            if (!grupos[key]) {
                grupos[key] = {
                    idOrdenMedica: analisis.idOrdenMedica,
                    numeroOrden: `${sucursalSeleccionada?.abreviatura || ''}${analisis.idOrdenMedicaMes || 'N/A'}`,
                    nombreCompleto: analisis.nombreCompleto,
                    fechaIngreso: analisis.fechaIngreso,
                    idModulo: analisis.idModulo,
                    nombreModulo: analisis.nombreModulo || analisis.idModulo,
                    analisis: []
                };
            }
            
            grupos[key].analisis.push(analisis);
        });
        
        return Object.values(grupos);
    }, [paginatedAnalisisClientes, sucursalSeleccionada]);

    // Función para seleccionar/deseleccionar todos los análisis de un módulo
    const toggleSelectAllModulo = (grupo) => {
        const todosSeleccionados = grupo.analisis.every(a => 
            selectedAnalisisClientes.some(s => s.idDetalle === a.idDetalle)
        );
        
        if (todosSeleccionados) {
            // Deseleccionar todos
            setSelectedAnalisisClientes([]);
        } else {
            // Seleccionar todos los análisis de este módulo (reemplazar cualquier selección anterior)
            setSelectedAnalisisClientes(grupo.analisis);
        }
    };

    // Verificar si todos los análisis de un módulo están seleccionados
    const todoModuloSeleccionado = (grupo) => {
        return grupo.analisis.length > 0 && grupo.analisis.every(a => 
            selectedAnalisisClientes.some(s => s.idDetalle === a.idDetalle)
        );
    };

    // Toggle expandir/contraer módulo
    const toggleExpandModule = (key) => {
        setExpandedModules(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    // Función para mostrar vista previa de PDF antes de ejecutar acción
    const showPdfPreviewAndExecute = (detalles, actionType, actionFunction) => {
        if (!detalles || detalles.length === 0) {
            Swal.fire({
                text: 'Por favor selecciona al menos un análisis.',
                icon: 'warning'
            });
            return;
        }

        // Set the pending action and open PDF preview
        setPendingValidationAction({ type: actionType, function: actionFunction, detalles: detalles });
        setOpenPdfPreview(true);
    };

    const handlePdfPreviewConfirm = () => {
        if (pendingValidationAction && pendingValidationAction.function) {
            pendingValidationAction.function();
        }
        setPendingValidationAction(null);
    };

    const handlePdfPreviewCancel = () => {
        setPendingValidationAction(null);
        setOpenPdfPreview(false);
    };

    // Funciones manejadoras

    // --- Funciones de validación para el detalle seleccionado ---

    function pickDetailFields(detail, fields) {
        return fields.reduce((acc, field) => {
            if (detail[field] !== undefined) {
                acc[field] = detail[field];
            }
            return acc;
        }, {});
    }






    const handleResultados = () => {
        if (selectedAnalisisClientes.length === 0) {
            Swal.fire({
                text: 'Por favor selecciona al menos un análisis.',
                icon: 'warning'
            });
            return;
        }

        Swal.fire({
            title: '¿Está seguro?',
            text: '¿Desea ingresar los resultados de los análisis seleccionados?',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                ejecutarResultados();
            }
        });
    };

    const handleImprimirDetalles = async () => {
        if (selectedAnalisisClientes.length === 0) {
            Swal.fire({
                text: 'Por favor, selecciona al menos un análisis para imprimir.',
                icon: 'warning'
            });
            return;
        }

        // Mostrar vista previa antes de confirmar
        const confirmPrint = async () => {
            await ejecutarImprimirDetalles();
        };

        showPdfPreviewAndExecute(selectedAnalisisClientes, 'imprimir', confirmPrint);
    };

    const ejecutarImprimirDetalles = async () => {

        try {
            // Determinar qué detalles imprimir basado en los filtros activos
            let detallesAImprimir = [...selectedAnalisisClientes];
            
            // Obtener el idOrdenMedica del primer detalle seleccionado
            const idOrdenMedica = selectedAnalisisClientes[0].idOrdenMedica;
            
            // Si hay módulo o análisis seleccionado, o ninguno (imprimir toda la orden)
            if (selectedModulo || analisisSeleccionado || (!selectedModulo && !analisisSeleccionado)) {
                // Llamar al API para obtener todos los detalles de esa orden
                const response = await fetch(`${server}/MgOrdenesMedicasDetalles/idOrdenTrabajo/${idOrdenMedica}`);
                if (response.ok) {
                    const data = await response.json();
                    const todosLosDetalles = data.$values || [];
                    
                    if (selectedModulo && !analisisSeleccionado) {
                        // CASO 1: Solo módulo seleccionado - filtrar por módulo
                        detallesAImprimir = todosLosDetalles.filter(d => 
                            d.idModulo === selectedModulo.idModulo
                        );
                        console.log(`📋 Módulo seleccionado: ${selectedModulo.nombreModulo}`);
                        console.log(`📊 Total detalles del módulo a imprimir: ${detallesAImprimir.length}`);
                    } 
                    else if (analisisSeleccionado && !selectedModulo) {
                        // CASO 2: Solo análisis seleccionado - filtrar por tipo de análisis
                        detallesAImprimir = todosLosDetalles.filter(d => 
                            d.idTipoAnalisis === analisisSeleccionado.idTipoAnalisis
                        );
                        console.log(`🔬 Análisis seleccionado: ${analisisSeleccionado.descripcionTipoAnalisis}`);
                        console.log(`📊 Total detalles del análisis a imprimir: ${detallesAImprimir.length}`);
                    }
                    else if (selectedModulo && analisisSeleccionado) {
                        // CASO 3: Ambos seleccionados - filtrar por módulo Y análisis
                        detallesAImprimir = todosLosDetalles.filter(d => 
                            d.idModulo === selectedModulo.idModulo && 
                            d.idTipoAnalisis === analisisSeleccionado.idTipoAnalisis
                        );
                        console.log(`📋 Filtros: Módulo=${selectedModulo.nombreModulo}, Análisis=${analisisSeleccionado.descripcionTipoAnalisis}`);
                        console.log(`📊 Total detalles filtrados a imprimir: ${detallesAImprimir.length}`);
                    }
                    else {
                        // CASO 4: Ninguno seleccionado - imprimir toda la orden
                        detallesAImprimir = todosLosDetalles;
                        console.log(`📄 Sin filtros - imprimiendo toda la orden`);
                        console.log(`📊 Total detalles de la orden a imprimir: ${detallesAImprimir.length}`);
                    }
                }
            }

            // Agrupar los detalles por tipo de aprobación
            const detallesPorTipoAprobacion = {};

            // Recorrer todos los detalles a imprimir y agruparlos
            detallesAImprimir.forEach(detalle => {
                // Usar "null" como clave si el tipo de aprobación es nulo
                const tipoAprobacion = detalle.idTipoAprobacion !== null
                    ? detalle.idTipoAprobacion.toString()
                    : "null";

                // Inicializar el array si no existe
                if (!detallesPorTipoAprobacion[tipoAprobacion]) {
                    detallesPorTipoAprobacion[tipoAprobacion] = [];
                }

                // Agregar el idDetalle al grupo correspondiente
                detallesPorTipoAprobacion[tipoAprobacion].push(detalle.idDetalle);
            });

            // Hacer una solicitud por cada grupo de tipo de aprobación
            for (const tipoAprobacion in detallesPorTipoAprobacion) {
                const idsDetalles = detallesPorTipoAprobacion[tipoAprobacion];

                const response = await fetch(`${server}/MgAnalisisGeneralResultadosAnalitoes/ImprimirvariosSeleccionadoExamenFormato`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(idsDetalles)
                });

                if (!response.ok) {
                    // Deserializar error específico para análisis con resultados no válidos
                    let errorMessage = `Error al imprimir los detalles con tipo de aprobación ${tipoAprobacion}`;
                    
                    try {
                        const errorData = await response.json();
                        
                        if (errorData.detail) {
                            // Error con formato RFC 7231 (como el de resultados no válidos)
                            errorMessage = errorData.detail;
                        } else if (errorData.message) {
                            // Error con formato message estándar
                            errorMessage = errorData.message;
                        }
                    } catch (parseError) {
                        // Si no se puede parsear, mantener mensaje genérico
                        console.error('Error parsing response JSON:', parseError);
                    }
                    
                    throw new Error(errorMessage);
                }

                // Obtener el blob de la respuesta y abrirlo en una nueva ventana
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const newWindow = window.open(url, '_blank');

                if (!newWindow) {
                    Swal.fire({
                        icon: 'warning',
                        title: 'Ventana Bloqueada',
                        text: 'Por favor, permite las ventanas emergentes para visualizar los documentos.'
                    });
                    // Salir del bucle si las ventanas están bloqueadas
                    break;
                }
            }

            Swal.fire({
                icon: 'success',
                title: `Detalles enviados a impresión (${Object.keys(detallesPorTipoAprobacion).length} grupo(s)).`,
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            console.error('Error al imprimir los detalles:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Ocurrió un error al imprimir los detalles.'
            });
        }
    };

    useEffect(() => {
        if (!openResultadosModal) {
            setIdOrdenTrabajo(null);
        }
    }, [openResultadosModal]);

    const ejecutarResultados = async () => {
        try {
            if (selectedAnalisisClientes.length === 0) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Selecciona al menos un análisis',
                    timer: 2000,
                });
                return;
            }

            const idOrdenMedicaMes = selectedAnalisisClientes[0].idOrdenMedicaMes;
            const response = await fetch(`${server}/MgOrdenesMedicas/OrdenMedica/${idOrdenMedicaMes}`);
            const ordenCompleta = await response.json();

            if (!ordenCompleta) throw new Error("No se pudo obtener la orden médica.");
            console.log(ordenCompleta);
            setOrdenTrabajoCliente({
                ...ordenCompleta,
                idOrdenMedicaMes: selectedAnalisisClientes[0].idOrdenMedicaMes
            });



            console.log(ordenTrabajoCliente);
            setOpenResultadosModal(true);

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Ocurrió un error al obtener los datos de la orden médica.',
            });
        }
    };



    const handleEntregada = () => {
        if (selectedAnalisisClientes.length === 0) {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            });
            return;
        }

        const selectedAnalisisCliente = selectedAnalisisClientes[0];
        
        // Parsear si viene en string separado por saltos de línea, por ejemplo
        const comentariosActuales = selectedAnalisisCliente.comentariosEntrega
            ? selectedAnalisisCliente.comentariosEntrega.split('\n').map(c => ({ comentarios: c }))
            : [];
        setComentariosEntrega(comentariosActuales);
        setOpenComentarioEntrega(true);
    };

    const handleReimprimirOrden = async () => {
        if (selectedAnalisisClientes.length === 0) {
            Swal.fire({
                text: 'Por favor selecciona al menos un análisis.',
                icon: 'warning'
            });
            return;
        }

        try {
            setLoading(true);
            
            // Obtener el ID de la orden médica
            const idOrdenMedica = selectedAnalisisClientes[0].idOrdenMedica;
            
            // Llamar al endpoint para reimprimir la orden
            const response = await fetch(`${server}/MgOrdenesMedicas/ImprimirOrdenMedica/${idOrdenMedica}`, {
                method: 'POST',
            });

            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const newWindow = window.open(url, '_blank');
                if (newWindow) {
                    newWindow.focus();
                } else {
                    alert('Por favor, permite las ventanas emergentes para previsualizar el documento.');
                }
            } else {
                throw new Error('Error al reimprimir la orden de trabajo');
            }
        } catch (error) {
            console.error('Error al reimprimir la orden:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error al reimprimir la orden',
                text: error.message || 'Ocurrió un error inesperado',
            });
        } finally {
            setLoading(false);
        }
    };



    const guardarComentarioEntrega = async (comentarios) => {
        if (selectedAnalisisClientes.length === 0) {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            });
            return;
        }

        const selectedAnalisisCliente = selectedAnalisisClientes[0];
        const textoComentarios = comentarios.map(c => c.comentarios).join('\n');
        
        try {
            const response = await fetch(`${server}/MgOrdenesMedicas/${selectedAnalisisCliente.idOrdenMedica}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ...selectedAnalisisCliente,
                    entregado: true,
                    comentariosEntrega: textoComentarios,
                    fechaModificacion: new Date().toISOString()
                }),
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Orden marcada como Entregada',
                    showConfirmButton: false,
                    timer: 1500,
                });
                setOpenComentarioEntrega(false);
                fetchAnalisisClientes(searchQuery);
            } else {
                const errorData = await response.json();
                const errorMessage =
                    errorData.message ||
                    (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Error inesperado');
                Swal.fire({ icon: 'error', title: `Error ${response.status}`, text: errorMessage });
            }
        } catch (error) {
            Swal.fire({ icon: 'error', title: 'Error al actualizar', text: error.message });
        }
    };






    // 2. Función para alternar la selección de un detalle
    const toggleDetalleSelection = (detalle) => {
        console.log(detalle);
        setDetalleSeleccionado(detalle);
        setSelectedDetalles((prevSelected) => {
            // Si ya está seleccionado, lo quitamos; si no, lo agregamos
            const isSelected = prevSelected.some(d => d.idDetalle === detalle.idDetalle);
            if (isSelected) {
                return prevSelected.filter(d => d.idDetalle !== detalle.idDetalle);
            } else {
                return [...prevSelected, detalle];
            }
        });
    };

    // Función para prevalidar análisis seleccionados
    const handlePrevalidar = async () => {
        if (selectedAnalisisClientes.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Sin selección',
                text: 'Selecciona al menos un análisis para prevalidar.'
            });
            return;
        }

        const validables = selectedAnalisisClientes.filter(d => puedePrevalidar(d));
        if (validables.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No se puede prevalidar',
                text: 'Los análisis seleccionados no pueden ser prevalidados en su estado actual.'
            });
            return;
        }

        // Mostrar vista previa antes de confirmar
        const confirmPrevalidation = () => {
            swalWithHighZIndex.fire({
                title: '¿Está seguro?',
                text: `¿Desea prevalidar ${validables.length} análisis seleccionado(s)?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, Prevalidar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        for (const detalle of validables) {
                            await ejecutarPrevalidarDetalle(detalle);
                        }
                        
                        // Actualizar el estado local de los análisis seleccionados
                        setSelectedAnalisisClientes(prev => 
                            prev.map(a => {
                                if (validables.some(v => v.idDetalle === a.idDetalle)) {
                                    return {
                                        ...a,
                                        idTipoAprobacion: 2,
                                        tipoValidacion: 'Pre-Validado',
                                        aprobadoPor: user ? user.codigoUsuario : "ADMIN",
                                        aprobadoPorNombre: user ? user.nombreUsuario : "ADMIN",
                                        fechaHoraAprobado: new Date().toISOString()
                                    };
                                }
                                return a;
                            })
                        );
                        
                        Swal.fire({
                            icon: 'success',
                            title: 'Pre-validado',
                            text: `${validables.length} análisis pre-validados correctamente.`,
                            timer: 2000
                        });
                        await fetchAnalisisClientes(searchQuery);
                    } catch (error) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: error.message || 'Error al prevalidar análisis.'
                        });
                    }
                }
            });
        };

        showPdfPreviewAndExecute(validables, 'prevalidar', confirmPrevalidation);
    };

    const ejecutarPrevalidarDetalle = async (detalle) => {
        const camposDeseados = ["idDetalle", "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo", "ingresadoPor", "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idTipoAnalisis", "idTipoPrecio", "valorDescuento", "evaluada"];
        const updateData = {
            ...pickDetailFields(detalle, camposDeseados),
            idTipoAprobacion: 2, // Pre Valido
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalle.idDetalle}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData)
        });

        if (!response.ok) {
            let errorMessage = `Error al prevalidar el análisis ${detalle.descripcionTipoAnalisis}`;
            try {
                const errorData = await response.json();
                if (errorData.detail) {
                    errorMessage = errorData.detail;
                } else if (errorData.message) {
                    errorMessage = errorData.message;
                }
            } catch (parseError) {
                console.error('Error parsing response JSON:', parseError);
            }
            throw new Error(errorMessage);
        }

        // Insertar en el histórico
        const histData = {
            ingresadoPor: user ? user.codigoUsuario : "ADMIN",
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            idTipoAprobacion: 2, // Pre Valido
            idOrdenMedicaDetalle: detalle.idDetalle
        };
        const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(histData)
        });
        if (!histResponse.ok) {
            throw new Error(`Error al insertar en el histórico para el análisis ${detalle.descripcionTipoAnalisis}`);
        }
        return updateData;
    };

    // Función para validar análisis seleccionados
    const handleValidar = async () => {
        if (selectedAnalisisClientes.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Sin selección',
                text: 'Selecciona al menos un análisis para validar.'
            });
            return;
        }

        const validables = selectedAnalisisClientes.filter(d => puedeValidar(d));
        if (validables.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No se puede validar',
                text: 'Los análisis seleccionados deben estar pre-validados primero.'
            });
            return;
        }

        // Mostrar vista previa antes de confirmar
        const confirmValidation = () => {
            swalWithHighZIndex.fire({
                title: '¿Está seguro?',
                text: `¿Desea validar ${validables.length} análisis seleccionado(s)?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, Validar',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        for (const detalle of validables) {
                            await ejecutarValidarDetalle(detalle);
                        }
                        
                        // Actualizar el estado local de los análisis seleccionados
                        setSelectedAnalisisClientes(prev => 
                            prev.map(a => {
                                if (validables.some(v => v.idDetalle === a.idDetalle)) {
                                    return {
                                        ...a,
                                        idTipoAprobacion: 3,
                                        tipoValidacion: 'Validado',
                                        aprobadoPor: user ? user.codigoUsuario : "ADMIN",
                                        aprobadoPorNombre: user ? user.nombreUsuario : "ADMIN",
                                        fechaHoraAprobado: new Date().toISOString()
                                    };
                                }
                                return a;
                            })
                        );
                        
                        Swal.fire({
                            icon: 'success',
                            title: 'Validado',
                            text: `${validables.length} análisis validados correctamente.`,
                            timer: 2000
                        });
                        await fetchAnalisisClientes(searchQuery);
                    } catch (error) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: error.message || 'Error al validar análisis.'
                        });
                    }
                }
            });
        };

        showPdfPreviewAndExecute(validables, 'validar', confirmValidation);
    };

    const ejecutarValidarDetalle = async (detalle) => {
        const camposDeseados = ["idDetalle", "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo", "ingresadoPor", "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idTipoAnalisis", "idTipoPrecio", "valorDescuento", "evaluada"];
        const updateData = {
            ...pickDetailFields(detalle, camposDeseados),
            idTipoAprobacion: 3, // Validado
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalle.idDetalle}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData)
        });

        if (!response.ok) {
            let errorMessage = `Error al validar el análisis ${detalle.descripcionTipoAnalisis}`;
            try {
                const errorData = await response.json();
                if (errorData.detail) {
                    errorMessage = errorData.detail;
                } else if (errorData.message) {
                    errorMessage = errorData.message;
                }
            } catch (parseError) {
                console.error('Error parsing response JSON:', parseError);
            }
            throw new Error(errorMessage);
        }

        // Insertar en el histórico
        const histData = {
            ingresadoPor: user ? user.codigoUsuario : "ADMIN",
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            idTipoAprobacion: 3, // Validado
            idOrdenMedicaDetalle: detalle.idDetalle
        };
        const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(histData)
        });
        if (!histResponse.ok) {
            throw new Error(`Error al insertar en el histórico para el análisis ${detalle.descripcionTipoAnalisis}`);
        }
        return updateData;
    };

    // Función para invalidar análisis seleccionados
    const handleInvalidar = async () => {
        if (selectedAnalisisClientes.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Sin selección',
                text: 'Selecciona al menos un análisis para invalidar.'
            });
            return;
        }

        const invalidables = selectedAnalisisClientes.filter(d => puedeInvalidar(d));
        if (invalidables.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No se puede invalidar',
                text: 'Los análisis seleccionados no están validados.'
            });
            return;
        }

        swalWithHighZIndex.fire({
            title: '¿Está seguro?',
            text: `¿Desea invalidar ${invalidables.length} análisis seleccionado(s)? Esto los regresará al estado prevalidado.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, Invalidar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    for (const detalle of invalidables) {
                        await ejecutarInvalidarDetalle(detalle);
                    }
                    
                    // Actualizar el estado local de los análisis seleccionados
                    setSelectedAnalisisClientes(prev => 
                        prev.map(a => {
                            if (invalidables.some(v => v.idDetalle === a.idDetalle)) {
                                return {
                                    ...a,
                                    idTipoAprobacion: 2,
                                    tipoValidacion: 'Pre-Validado',
                                    aprobadoPor: user ? user.codigoUsuario : "ADMIN",
                                    aprobadoPorNombre: user ? user.nombreUsuario : "ADMIN",
                                    fechaHoraAprobado: new Date().toISOString()
                                };
                            }
                            return a;
                        })
                    );
                    
                    Swal.fire({
                        icon: 'success',
                        title: 'Invalidado',
                        text: `${invalidables.length} análisis invalidados correctamente.`,
                        timer: 2000
                    });
                    await fetchAnalisisClientes(searchQuery);
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error.message || 'Error al invalidar análisis.'
                    });
                }
            }
        });
    };

    const ejecutarInvalidarDetalle = async (detalle) => {
        const camposDeseados = ["idDetalle", "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo", "ingresadoPor", "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idTipoAnalisis", "idTipoPrecio", "valorDescuento", "evaluada"];
        const updateData = {
            ...pickDetailFields(detalle, camposDeseados),
            idTipoAprobacion: 2, // Volver a Pre Valido
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalle.idDetalle}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData)
        });

        if (!response.ok) {
            let errorMessage = `Error al invalidar el análisis ${detalle.descripcionTipoAnalisis}`;
            try {
                const errorData = await response.json();
                if (errorData.detail) {
                    errorMessage = errorData.detail;
                } else if (errorData.message) {
                    errorMessage = errorData.message;
                }
            } catch (parseError) {
                console.error('Error parsing response JSON:', parseError);
            }
            throw new Error(errorMessage);
        }

        // Insertar en el histórico
        const histData = {
            ingresadoPor: user ? user.codigoUsuario : "ADMIN",
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            idTipoAprobacion: 2, // Pre Valido
            idOrdenMedicaDetalle: detalle.idDetalle
        };
        const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(histData)
        });
        if (!histResponse.ok) {
            throw new Error(`Error al insertar en el histórico para el análisis ${detalle.descripcionTipoAnalisis}`);
        }
        return updateData;
    };

    // Función para quitar pre-validación
    const handleQuitarPrevalidacion = async () => {
        if (selectedAnalisisClientes.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'Sin selección',
                text: 'Selecciona al menos un análisis para quitar la pre-validación.'
            });
            return;
        }

        const quitables = selectedAnalisisClientes.filter(d => puedeQuitarPrevalidacion(d));
        if (quitables.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: 'No se puede quitar pre-validación',
                text: 'Los análisis seleccionados no están pre-validados.'
            });
            return;
        }

        swalWithHighZIndex.fire({
            title: '¿Está seguro?',
            text: `¿Desea quitar la pre-validación de ${quitables.length} análisis seleccionado(s)?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, Quitar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    for (const detalle of quitables) {
                        await ejecutarQuitarPrevalidacionDetalle(detalle);
                    }
                    
                    // Actualizar el estado local de los análisis seleccionados
                    setSelectedAnalisisClientes(prev => 
                        prev.map(a => {
                            if (quitables.some(v => v.idDetalle === a.idDetalle)) {
                                return {
                                    ...a,
                                    idTipoAprobacion: 1,
                                    tipoValidacion: null,
                                    aprobadoPor: "",
                                    aprobadoPorNombre: "",
                                    fechaHoraAprobado: null
                                };
                            }
                            return a;
                        })
                    );
                    
                    Swal.fire({
                        icon: 'success',
                        title: 'Pre-validación eliminada',
                        text: `${quitables.length} análisis actualizados correctamente.`,
                        timer: 2000
                    });
                    await fetchAnalisisClientes(searchQuery);
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: error.message || 'Error al quitar pre-validación.'
                    });
                }
            }
        });
    };

    const ejecutarQuitarPrevalidacionDetalle = async (detalle) => {
        const camposDeseados = ["idDetalle", "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo", "ingresadoPor", "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idTipoAnalisis", "idTipoPrecio", "valorDescuento", "evaluada"];
        const updateData = {
            ...pickDetailFields(detalle, camposDeseados),
            idTipoAprobacion: 1, // Sin Pre Validar
            aprobadoPor: "",
            fechaHoraAprobado: null,
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalle.idDetalle}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData)
        });

        if (!response.ok) {
            let errorMessage = `Error al quitar pre-validación del análisis ${detalle.descripcionTipoAnalisis}`;
            try {
                const errorData = await response.json();
                if (errorData.detail) {
                    errorMessage = errorData.detail;
                } else if (errorData.message) {
                    errorMessage = errorData.message;
                }
            } catch (parseError) {
                console.error('Error parsing response JSON:', parseError);
            }
            throw new Error(errorMessage);
        }

        // Insertar en el histórico
        const histData = {
            ingresadoPor: user ? user.codigoUsuario : "ADMIN",
            aprobadoPor: "",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            idTipoAprobacion: 1, // Sin Pre Validar
            idOrdenMedicaDetalle: detalle.idDetalle
        };
        const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(histData)
        });
        if (!histResponse.ok) {
            throw new Error(`Error al insertar en el histórico para el análisis ${detalle.descripcionTipoAnalisis}`);
        }
        return updateData;
    };

    const handleLegacy = async () => {
        if (selectedAnalisisClientes.length !== 1) {
            Swal.fire({
                icon: 'warning',
                title: 'Selecciona un detalle',
                text: 'Debes seleccionar exactamente un análisis para abrir el resultado legacy.'
            });
            return;
        }
        const idDetalle = selectedAnalisisClientes[0].idDetalle;
        setOpenLegacyModal(true);
        setLegacyLoading(true);
        setLegacyError(null);
        setLegacyUrl(null);
        try {
            const url = `${server}/MgAnalisisGeneralResultadosAnalitoes/LegacyUrl/${idDetalle}`;
            console.log('🔗 Solicitando URL Legacy:', url);
            const resp = await fetch(url);
            if (!resp.ok) {
                let errText = 'No se pudo generar la URL del sistema legacy';
                try {
                    const data = await resp.json();
                    errText = data?.message || errText;
                } catch {}
                throw new Error(errText);
            }
            const data = await resp.json();
            if (!data?.url) throw new Error('El backend no devolvió una URL válida');
            console.log('✅ URL Legacy recibida:', data.url);
            setLegacyUrl(data.url);
        } catch (e) {
            console.error('❌ Error Legacy:', e);
            setLegacyError(e.message || 'Error desconocido al generar la URL legacy');
        } finally {
            setLegacyLoading(false);
        }
    };





    return (
        <>
            <div className="right_col" role="main">
                <div className="x_title"></div>
                <div className="x_content">
                    <h2>Listado de Ordenes de Trabajo</h2>
                    <br />
                    <Grid container spacing={2} alignItems="center" style={{ marginBottom: '20px' }}>
                        {/* Autocomplete sucursal */}
                        <Grid item xs={12} md={3}>
                            <Autocomplete
                                size="small"
                                options={sucursales}
                                getOptionLabel={(option) => option.nombreSucursal || ''}
                                value={typeof sucursalSeleccionada === 'object' ? sucursalSeleccionada : null}
                                onChange={handleSucursalSeleccionada}
                                renderInput={(params) => (
                                    <TextField {...params} label="Sucursal" variant="outlined" fullWidth />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={3}>
                            <Autocomplete
                                size="small"
                                options={modulos}
                                getOptionLabel={(option) => option.nombreModulo || ''}
                                value={selectedModulo}
                                onChange={(event, newValue) => setSelectedModulo(newValue)}
                                renderInput={(params) => (
                                    <TextField {...params} label="Módulo" variant="outlined" fullWidth />
                                )}
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <Autocomplete
                                size="small"
                                options={filteredAnalisis}
                                getOptionLabel={(option) => option?.descripcionTipoAnalisis || ''}
                                value={analisisSeleccionado}
                                onChange={async (e, newValue) => {
                                    setAnalisisSeleccionado(newValue);
                                }}
                                isOptionEqualToValue={(option, value) => option?.idTipoAnalisis === value?.idTipoAnalisis} // Comparar por ID de tipo de análisis
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        size="small"
                                        label="Análisis"
                                        variant="outlined"
                                        inputRef={refAutocompleteAnalisis}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                const value = refAutocompleteAnalisis.current?.value || '';
                                                const highlighted = analisis.find(
                                                    (item) => item.descripcionTipoAnalisis.toLowerCase() === value.toLowerCase()
                                                );
                                                if (highlighted) {
                                                    handleAnalisisKeyDown(e, highlighted);
                                                }
                                            }
                                        }}
                                    />
                                )}
                            />

                        </Grid>

                        { /* Fechas */}
                        <Grid item xs={12} md={3}>
                            <TextField
                                size="small"
                                label="Fecha Inicio"
                                type="date"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={fechaInicio}
                                onChange={handleFechaInicioChange}
                            />
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <TextField
                                size="small"
                                label="Fecha Fin"
                                type="date"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{ shrink: true }}
                                value={fechaFin}
                                onChange={handleFechaFinChange}
                            />
                        </Grid>
                        <Grid item xs={10}>
                            <TextField
                                size="small"
                                variant="outlined"
                                label="Buscar Orden de Trabajo"
                                fullWidth
                                value={searchQuery}
                                onChange={handleSearchChange}
                                onKeyDown={handleKeyDown}
                            />
                        </Grid>
                        <Grid item xs={2}>
                            <Button variant="contained" color="primary" onClick={handleSearch} size="small" disabled={!tienePermiso('Buscar Análisis Cliente')}>
                                Buscar
                            </Button>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button 
                                size="small" 
                                variant="contained" 
                                color="primary" 
                                onClick={handleResultados} 
                                style={{ marginLeft: '5px' }} 
                                sx={{ minWidth: '120px', padding: '8px 16px', fontSize: '0.875rem' }}
                                startIcon={<FontAwesomeIcon icon={faEnvelope} />}
                                disabled={!tienePermiso('Resultados Análisis Cliente')}
                            >
                                Resultados
                            </Button>
                            <Button 
                                size="small" 
                                variant="contained" 
                                color="success" 
                                onClick={handlePrevalidar}
                                disabled={!todosLosSeleccionadosPuedenPrevalidar() || !tienePermiso('Prevalidar Análisis Cliente')}
                                style={{ marginLeft: '10px' }} 
                                sx={{ minWidth: '120px', padding: '8px 16px', fontSize: '0.875rem' }}
                            >
                                Prevalidar
                            </Button>
                            <Button 
                                size="small" 
                                variant="contained" 
                                color="success" 
                                onClick={handleQuitarPrevalidacion}
                                disabled={!todosLosSeleccionadosPuedenQuitarPrevalidacion() || !tienePermiso('Quitar Prevalidación Análisis Cliente')}
                                style={{ marginLeft: '10px' }} 
                                sx={{ minWidth: '140px', padding: '8px 16px', fontSize: '0.875rem' }}
                            >
                                Quitar Prev.
                            </Button>
                            <Button 
                                size="small" 
                                variant="contained" 
                                color="info" 
                                onClick={handleValidar}
                                disabled={!todosLosSeleccionadosPuedenValidar() || !tienePermiso('Validar Análisis Cliente')}
                                style={{ marginLeft: '10px' }} 
                                sx={{ minWidth: '120px', padding: '8px 16px', fontSize: '0.875rem' }}
                            >
                                Validar
                            </Button>
                            <Button 
                                size="small" 
                                variant="contained" 
                                color="warning" 
                                onClick={handleInvalidar}
                                disabled={!todosLosSeleccionadosPuedenInvalidar() || !tienePermiso('Invalidar Análisis Cliente')}
                                style={{ marginLeft: '10px' }} 
                                sx={{ minWidth: '120px', padding: '8px 16px', fontSize: '0.875rem' }}
                            >
                                Invalidar
                            </Button>
                            <Button 
                                size="small" 
                                variant="contained" 
                                color="secondary" 
                                onClick={handleImprimirDetalles} 
                                style={{ marginLeft: '10px' }} 
                                sx={{ minWidth: '120px', padding: '8px 16px', fontSize: '0.875rem' }}
                                startIcon={<FontAwesomeIcon icon={faPrint} />}
                                disabled={!tienePermiso('Imprimir Análisis Cliente')}
                            >
                                Imprimir
                            </Button>
                            <Button 
                                size="small" 
                                variant="contained" 
                                color="secondary" 
                                onClick={handleLegacy} 
                                style={{ marginLeft: '10px' }} 
                                sx={{ minWidth: '120px', padding: '8px 16px', fontSize: '0.875rem' }}
                                startIcon={<FontAwesomeIcon icon={faClockRotateLeft} />}
                                title="Resultados del sistema anterior (App móvil legacy)"
                                disabled={!tienePermiso('Legacy Análisis Cliente')}
                            >
                                Legacy
                            </Button>
                        </Grid>
                    </Grid>
                    {loading ? (
                        <div style={{ textAlign: 'center', marginTop: '20px' }}>
                            <CircularProgress />
                        </div>
                    ) : (
                        <TableContainer component={Paper} style={{ marginTop: '20px' }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ fontWeight: 'bold', width: '50px' }}></TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '150px' }}>Fecha</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '100px' }}>N° Orden</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '300px' }}>Nombre Cliente</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '120px' }}>Módulo</TableCell>
                                        <TableCell style={{ fontWeight: 'bold', minWidth: '200px' }}>Columnas</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {analisisAgrupadosPorOrdenYModulo.map((grupo) => {
                                        const key = `${grupo.idOrdenMedica}-${grupo.idModulo}`;
                                        const isExpanded = expandedModules[key] || false;
                                        const todoSeleccionado = todoModuloSeleccionado(grupo);

                                        return (
                                            <React.Fragment key={key}>
                                                {/* Fila de cabecera del módulo */}
                                                <TableRow 
                                                    style={{ 
                                                        backgroundColor: '#f0f8ff',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => toggleExpandModule(key)}
                                                >
                                                    <TableCell style={{ padding: '8px' }}>
                                                        <Box display="flex" alignItems="center">
                                                            <Checkbox
                                                                checked={todoSeleccionado}
                                                                indeterminate={!todoSeleccionado && grupo.analisis.some(a => 
                                                                    selectedAnalisisClientes.some(s => s.idDetalle === a.idDetalle)
                                                                )}
                                                                onChange={(e) => {
                                                                    e.stopPropagation();
                                                                    toggleSelectAllModulo(grupo);
                                                                }}
                                                                onClick={(e) => e.stopPropagation()}
                                                            />
                                                            <IconButton size="small">
                                                                {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                                            </IconButton>
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell style={{ padding: '8px', fontWeight: 'bold' }}>
                                                        {grupo.fechaIngreso ? dayjs(grupo.fechaIngreso).format('DD/MM/YYYY') : 'N/A'}
                                                    </TableCell>
                                                    <TableCell style={{ padding: '8px', fontWeight: 'bold' }}>
                                                        {grupo.numeroOrden}
                                                    </TableCell>
                                                    <TableCell style={{ padding: '8px', fontWeight: 'bold' }}>
                                                        {grupo.nombreCompleto}
                                                    </TableCell>
                                                    <TableCell style={{ padding: '8px', fontWeight: 'bold' }}>
                                                        <Box 
                                                            sx={{
                                                                backgroundColor: '#2196f3',
                                                                color: 'white',
                                                                padding: '4px 12px',
                                                                borderRadius: '16px',
                                                                display: 'inline-block',
                                                                fontWeight: 'bold',
                                                                fontSize: '0.85rem'
                                                            }}
                                                        >
                                                            {grupo.nombreModulo}
                                                        </Box>
                                                    </TableCell>
                                                    <TableCell style={{ padding: '8px' }}>
                                                        <Typography variant="body2" color="textSecondary">
                                                            {grupo.analisis.length} análisis
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>

                                                {/* Filas expandidas con los análisis del módulo */}
                                                <TableRow>
                                                    <TableCell colSpan={6} style={{ padding: 0, border: 'none' }}>
                                                        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                                                            <Table size="small">
                                                                <TableHead>
                                                                    <TableRow style={{ backgroundColor: '#fafafa' }}>
                                                                        <TableCell sx={{ fontWeight: 'bold', width: '50px' }}></TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', minWidth: '300px' }}>Análisis</TableCell>
                                                                        <TableCell sx={{ fontWeight: 'bold' }}>Sub Total</TableCell>
                                                                        <TableCell sx={{ fontWeight: 'bold' }}>Descuento</TableCell>
                                                                        <TableCell sx={{ fontWeight: 'bold' }}>Total</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', minWidth: '120px' }}>Tipo Validación</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', minWidth: '150px' }}>Aprobado Por</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', minWidth: '180px' }}>Estado</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold' }}>Comentario</TableCell>
                                                                        <TableCell sx={{ fontWeight: 'bold' }}>Entreg.</TableCell>
                                                                        <TableCell sx={{ fontWeight: 'bold' }}>Medio</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', minWidth: '150px' }}>Origen</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', minWidth: '150px' }}>Médico</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', minWidth: '180px' }}>F. Recepción</TableCell>
                                                                        <TableCell style={{ fontWeight: 'bold', minWidth: '180px' }}>F. Entrega</TableCell>
                                                                    </TableRow>
                                                                </TableHead>
                                                                <TableBody>
                                                                    {grupo.analisis.map((analisisCliente) => (
                                                                        <TableRow key={analisisCliente.idDetalle} style={{ backgroundColor: 'white' }}>
                                                                            <TableCell style={{ padding: '4px' }}>
                                                                                <Checkbox
                                                                                    checked={selectedAnalisisClientes.some(a => a.idDetalle === analisisCliente.idDetalle)}
                                                                                    onChange={() => handleSelectOrdenTrabajo(analisisCliente)}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell style={{ padding: '4px' }}>{analisisCliente.descripcionTipoAnalisis || 'N/A'}</TableCell>
                                                                            <TableCell style={{ padding: '4px' }}>{((Number(analisisCliente.valorVenta || 0) + Number(analisisCliente.valorDescuento || 0))).toFixed(2)}</TableCell>
                                                                            <TableCell style={{ padding: '4px' }}>{(analisisCliente.valorDescuento || 0).toFixed(2)}</TableCell>
                                                                            <TableCell style={{ padding: '4px' }}>{(analisisCliente.valorVenta || 0).toFixed(2)}</TableCell>
                                                                            <TableCell style={{ padding: '4px', fontSize: '0.75rem' }}>
                                                                                <div style={{ 
                                                                                    backgroundColor: analisisCliente.tipoValidacion ? '#e8f5e8' : '#f5f5f5', 
                                                                                    padding: '2px 6px', 
                                                                                    borderRadius: '12px',
                                                                                    color: analisisCliente.tipoValidacion ? '#2e7d32' : '#666',
                                                                                    fontWeight: 'bold',
                                                                                    fontSize: '0.7rem'
                                                                                }}>
                                                                                    {analisisCliente.tipoValidacion || 'Sin validar'}
                                                                                </div>
                                                                            </TableCell>
                                                                            <TableCell style={{ padding: '4px', fontSize: '0.75rem' }}>
                                                                                <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
                                                                                    <div style={{ fontWeight: 'bold' }}>
                                                                                        {analisisCliente.aprobadoPorNombre || 'Sin aprobar'}
                                                                                    </div>
                                                                                    {analisisCliente.fechaHoraAprobado && (
                                                                                        <div style={{ color: '#666', fontSize: '0.65rem' }}>
                                                                                            {analisisCliente.fechaHoraAprobado ? dayjs(analisisCliente.fechaHoraAprobado).format('DD/MM/YY HH:mm') : ''}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </TableCell>
                                                                            <TableCell style={{ padding: '4px' }}>{analisisCliente.modificacion === 1 ? "Pendiente" : (analisisCliente.descripcionModificacion || 'N/A')}</TableCell>
                                                                            <TableCell style={{ padding: '4px' }}>{analisisCliente.comentariosEntrega || ''}</TableCell>
                                                                            <TableCell style={{ padding: '4px' }}>{analisisCliente.entregado ? 'Sí' : 'No'}</TableCell>
                                                                            <TableCell style={{ padding: '4px' }}>
                                                                                {(analisisCliente.enviarXWhatsapp && <FontAwesomeIcon icon={faWhatsapp} title="WhatsApp" style={{ margin: '0 2px' }} />) || ''}
                                                                                {(analisisCliente.enviarXApp && <FontAwesomeIcon icon={faMobileAlt} title="App" style={{ margin: '0 2px' }} />) || ''}
                                                                                {(analisisCliente.enviarXCorreo && <FontAwesomeIcon icon={faEnvelope} title="Email" style={{ margin: '0 2px' }} />) || ''}
                                                                                {(analisisCliente.imprimir && <FontAwesomeIcon icon={faPrint} title="Impreso" style={{ margin: '0 2px' }} />) || ''}
                                                                                {!analisisCliente.enviarXWhatsapp && !analisisCliente.enviarXApp && !analisisCliente.enviarXCorreo && !analisisCliente.imprimir && 'N/A'}
                                                                            </TableCell>
                                                                            <TableCell style={{ padding: '4px' }}>{analisisCliente.origen || 'N/A'}</TableCell>
                                                                            <TableCell style={{ padding: '4px' }}>{analisisCliente.nombreMedico || 'N/A'}</TableCell>
                                                                            <TableCell style={{ padding: '4px' }}>{analisisCliente.fechaRecepcion ? dayjs(analisisCliente.fechaRecepcion).format('DD/MM/YYYY hh:mm A') : 'N/A'}</TableCell>
                                                                            <TableCell style={{ padding: '4px' }}>{analisisCliente.fechaEntrega ? dayjs(analisisCliente.fechaEntrega).format('DD/MM/YYYY hh:mm A') : 'N/A'}</TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            </Table>
                                                        </Collapse>
                                                    </TableCell>
                                                </TableRow>
                                            </React.Fragment>
                                        );
                                    })}
                                </TableBody>
                            </Table>

                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={totalAnalisisClientes}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage="Filas por página:"
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                            />
                        </TableContainer>
                    )}

                    <Modal
                        open={openModal}
                        onClose={() => setOpenModal(false)}
                        aria-labelledby="modal-title"
                        aria-describedby="modal-description"
                    >
                        <div style={modalStyle}>
                            {ordenTrabajoData && (
                                <GestionOrdenTrabajo
                                    ordenTrabajo={ordenTrabajoData.OrdenTrabajo}
                                    modo={ordenTrabajoData.modo}
                                    onClose={async () => {
                                        setOpenModal(false);
                                        await fetchAnalisisClientes(searchQuery);
                                        const ordenActualizada = await fetch(`${server}/MgOrdenesMedicas/${ordenTrabajoData.OrdenTrabajo.idOrdenMedica}`);
                                        if (ordenActualizada.ok) {
                                            const data = await ordenActualizada.json();
                                            await handleSelectOrdenTrabajo(data);
                                        }
                                    }}

                                />
                            )}
                        </div>
                    </Modal>

                    {/* Modal: Vista Legacy (por idDetalle) */}
                    <Dialog 
                        open={openLegacyModal}
                        onClose={() => setOpenLegacyModal(false)}
                        maxWidth="lg"
                        fullWidth
                        PaperProps={{
                            style: { height: '90vh', maxHeight: '90vh' }
                        }}
                    >
                        <DialogTitle>
                            Resultados Sistema Legacy
                            <IconButton
                                aria-label="close"
                                onClick={() => setOpenLegacyModal(false)}
                                sx={{ position: 'absolute', right: 8, top: 8 }}
                            >
                                <CloseIcon />
                            </IconButton>
                        </DialogTitle>
                        <DialogContent dividers style={{ padding: 0, height: 'calc(90vh - 64px)', position: 'relative' }}>
                            {legacyLoading && (
                                <Box
                                    display="flex"
                                    flexDirection="column"
                                    alignItems="center"
                                    justifyContent="center"
                                    style={{ position: 'absolute', inset: 0, zIndex: 10, backgroundColor: 'white' }}
                                >
                                    <CircularProgress size={60} />
                                    <Typography variant="body1" style={{ marginTop: 16 }}>
                                        Generando enlace del sistema legacy...
                                    </Typography>
                                </Box>
                            )}
                            {legacyError && !legacyLoading && (
                                <Box p={3}>
                                    <Alert severity="warning">{legacyError}</Alert>
                                </Box>
                            )}
                            {legacyUrl && !legacyLoading && !legacyError && (
                                <iframe
                                    src={legacyUrl}
                                    title="Sistema Legacy"
                                    style={{ width: '100%', height: '100%', border: 'none' }}
                                />
                            )}
                        </DialogContent>
                    </Dialog>
                    <Modal
                        open={openFacturaModal}
                        onClose={() => setOpenFacturaModal(false)}
                        aria-labelledby="modal-title-factura"
                        aria-describedby="modal-description-factura"
                    >
                        <div style={modalStyle}>
                            {facturaData && (
                                <GestionFactura
                                    datosFactura={facturaData}
                                    onClose={() => setOpenFacturaModal(false)}
                                />
                            )}
                        </div>
                    </Modal>

                    <Modal
                        open={openResultadosModal}
                        onClose={() => setOpenResultadosModal(false)}
                        aria-labelledby="modal-title-resultados"
                        aria-describedby="modal-description-resultados"
                    >
                        <div style={modalStyle}>
                            {selectedAnalisisClientes.length > 0 && (
                                <Resultados
                                    open={openResultadosModal}
                                    handleClose={() => setOpenResultadosModal(false)}
                                    OrdenTrabajo={ordenTrabajoCliente}
                                    analisisFiltrados={selectedAnalisisClientes}
                                />
                            )}
                        </div>
                    </Modal>


                    <Modal open={openTomaMuestra} onClose={() => setOpenTomaMuestra(false)}>
                        <Box sx={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '80%',
                            maxHeight: '90vh',
                            overflowY: 'auto',
                            backgroundColor: 'white',
                            padding: '20px',
                            borderRadius: '8px'
                        }}>
                            <TomaMuestra
                                selectedOrden={selectedAnalisisClientes.length > 0 ? selectedAnalisisClientes[0] : null}
                                selectedDetalles={selectedDetalles}
                                open={openTomaMuestra}
                                onClose={() => setOpenTomaMuestra(false)}
                            />
                        </Box>
                    </Modal>

                    <ComentariosEntregaModal
                        open={openComentarioEntrega}
                        initialComentarios={comentariosEntrega}
                        onClose={() => setOpenComentarioEntrega(false)}
                        onSave={guardarComentarioEntrega}
                    />

                    <PdfPreviewModal
                        open={openPdfPreview}
                        onConfirm={handlePdfPreviewConfirm}
                        onClose={handlePdfPreviewCancel}
                        selectedDetalles={pendingValidationAction?.detalles || selectedAnalisisClientes}
                        actionType={pendingValidationAction?.type}
                    />



                </div>
            </div>
        </>
    );
}

export default AnalisisClientes;
